import { roundFloat } from '../util/math-util';
import { LEFT_SIDE, RIGHT_SIDE, } from '../types';
import { EnabledDimensions } from './timeseries-dims';
export var FORCE_INDEX = 0;
export var MOMENT_INDEX = 1;
var VERSION = 1;
var analtyicElements = [
    {
        labelBase: 'Ground',
        sides: true,
        features: ['Force'],
    },
    {
        labelBase: 'Accel Ground',
        sides: true,
        features: ['Force'],
    },
    {
        labelBase: 'Sacral',
        sides: false,
        features: ['Force', 'MomentModel', 'Moment', 'Angle'],
    },
    {
        labelBase: 'Hip',
        sides: true,
        features: ['Force', 'MomentModel', 'Moment', 'Angle'],
    },
    {
        labelBase: 'Knee',
        sides: true,
        features: ['Force', 'MomentModel', 'Moment', 'Angle'],
    },
    {
        labelBase: 'CoM',
        sides: false,
        features: ['Point'],
    },
];
function keyFromLabel(label) {
    return label.toLocaleLowerCase().split(' ')
        .join('_');
}
function unitsForFeature(type) {
    if (type === 'Force') {
        return 'N/kg';
    }
    if (type === 'Moment' || type === 'MomentModel') {
        return 'Nm/kg';
    }
    if (type === 'Angle') {
        return 'deg';
    }
    if (type === 'Point') {
        return 'm';
    }
    throw new Error("unitsForFeature requested for unknown type - " + type);
}
function dimensionsForFeature(type) {
    if (type === 'Force') {
        return ['Total', 'X', 'Y', 'Z'];
    }
    if (type === 'MomentModel') {
        return ['Total', 'X', 'Y', 'Z'];
    }
    if (type === 'Moment') {
        return ['Sagital', 'Coronal', 'Transverse'];
    }
    if (type === 'Angle') {
        return ['Sagital', 'Coronal', 'Transverse'];
    }
    if (type === 'Point') {
        return ['X', 'Y', 'Z'];
    }
    throw new Error("dimensionsForFeature requested for unknown type - " + type);
}
var LEFT_SIDE_STR = ' Left';
var RIGHT_SIDE_STR = ' Right';
var GRF_COLOR_BASE = 0xcc0000;
var SACRAL_COLOR_BASE = 0x00cc00;
var HIP_COLOR_BASE = 0xee0000;
var KNEE_COLOR_BASE = 0x00ee00;
var COM_COLOR_BASE = 0xdd0000;
var Colors = [
    GRF_COLOR_BASE,
    GRF_COLOR_BASE,
    SACRAL_COLOR_BASE,
    HIP_COLOR_BASE,
    KNEE_COLOR_BASE,
    COM_COLOR_BASE,
];
function colorForDimension(bodyAnalyticIndex, side) {
    var n = Colors[bodyAnalyticIndex];
    if (side === LEFT_SIDE_STR) {
        n += 0x88;
    }
    return '#' + n.toString(16).padStart(6, '0');
}
function getSideIndex(side) {
    if (side === LEFT_SIDE_STR) {
        return LEFT_SIDE;
    }
    if (side === RIGHT_SIDE_STR) {
        return RIGHT_SIDE;
    }
    return undefined;
}
function fieldsForSide(bodyAnalyticIndex, side, bodyAnalyticBase) {
    function FieldsFromFeature(acc, featureName, featureIndex) {
        var featuresForSide = dimensionsForFeature(featureName).map(function (dimension) {
            var label = bodyAnalyticBase.labelBase + " " + featureName + " " + dimension + side;
            var key = keyFromLabel(label);
            var color = colorForDimension(bodyAnalyticIndex, side);
            return {
                label: label,
                key: key,
                units: unitsForFeature(featureName),
                enabled: EnabledDimensions.includes(key),
                color: color,
                bodyAnalyticIndex: bodyAnalyticIndex,
                featureIndex: featureIndex,
                sideIndex: getSideIndex(side),
                dimension: dimension,
            };
        });
        acc.push.apply(acc, featuresForSide);
        return acc;
    }
    return bodyAnalyticBase.features.reduce(FieldsFromFeature, []);
}
function fieldCreator(acc, bodyAnalyticBase, bodyAnalyticIndex) {
    if (bodyAnalyticBase.sides) {
        acc.push.apply(acc, fieldsForSide(bodyAnalyticIndex, LEFT_SIDE_STR, bodyAnalyticBase));
        acc.push.apply(acc, fieldsForSide(bodyAnalyticIndex, RIGHT_SIDE_STR, bodyAnalyticBase));
    }
    else {
        acc.push.apply(acc, fieldsForSide(bodyAnalyticIndex, '', bodyAnalyticBase));
    }
    return acc;
}
export var AnalyticsFields = analtyicElements.reduce(fieldCreator, []);
var AnalyticsTuple = (function () {
    function AnalyticsTuple(timestamp, tuple) {
        this.timestamp = timestamp;
        this.version = VERSION;
        this.tuple = tuple;
    }
    return AnalyticsTuple;
}());
export { AnalyticsTuple };
function getDimensionIndex(dimensionName) {
    switch (dimensionName) {
        case 'X':
            return 'x';
        case 'Y':
            return 'y';
        case 'Z':
            return 'z';
        case 'Sagital':
            return 0;
        case 'Coronal':
            return 1;
        case 'Transverse':
            return 2;
        default:
            throw new Error("getDimensionIndex called for unknown dimension " + dimensionName);
    }
}
export function parseTuple(key, tuple) {
    var field = AnalyticsFields.find(function (el) { return el.key === key; });
    var result = 0;
    if (field === undefined) {
        throw new Error("parseTuple failed to find analytics key '" + key + "' in AnalyticsElements");
    }
    if (field.sideIndex === undefined) {
        if (field.dimension === 'Total') {
            result = roundFloat(tuple[field.bodyAnalyticIndex][field.featureIndex].norm(), 3);
        }
        else {
            result = tuple[field.bodyAnalyticIndex][field.featureIndex][getDimensionIndex(field.dimension)];
        }
    }
    else {
        if (field.dimension === 'Total') {
            result = roundFloat(tuple[field.bodyAnalyticIndex][field.featureIndex][field.sideIndex].norm(), 3);
        }
        else {
            result = tuple[field.bodyAnalyticIndex][field.featureIndex][field.sideIndex][getDimensionIndex(field.dimension)];
        }
    }
    return result;
}
//# sourceMappingURL=analytics-tuple.js.map